<template>
  <div class="ps-relative ps-mt-4">
    <div
      :style="screenStyles"
      class="ps-w-full ps-border-solid ps-border-8 ps-border-brand-brown-200 ps-rounded-lg ps-bg-brand-brown-50 ps-relative"
    >
      <div class="ps-absolute ps-inset-0">
        <div
          :style="browswerStyles"
          class="ps-browser ps-flex ps-flex-col ps-relative"
        >
          <div
            :style="toolbarStyles"
            class="ps-bg-purple-200 ps-rounded-t ps-flex ps-items-center ps-pl-3"
          >
            <div class="ps-rounded-full ps-h-1 ps-w-1 ps-bg-white"></div>
            <div
              class="ps-rounded-full ps-h-1 ps-w-1 ps-bg-white ps-ml-1"
            ></div>
            <div
              class="ps-rounded-full ps-h-1 ps-w-1 ps-bg-white ps-ml-1"
            ></div>
          </div>
          <div class="ps-mt-px ps-bg-purple-200 ps-flex-auto"></div>
          <div
            :style="browserInnerStyles"
            class="ps-bg-purple-600 ps-absolute"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BrowserDiagram',
  props: {
    browser: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    screen() {
      return this.browser.screen_size
    },
    window() {
      return this.browser.window_size
    },
    screenHeight() {
      return (this.screen.height / this.screen.width) * 100
    },
    browserWidth() {
      return (this.window.outerWidth / this.screen.width) * 100
    },
    browserHeight() {
      return (this.window.outerHeight / this.screen.height) * 100
    },
    browserInnerWidth() {
      return (this.window.innerWidth / this.window.outerWidth) * 100
    },
    browserInnerHeight() {
      return (this.window.innerHeight / this.window.outerHeight) * 100
    },
    toolbarHeight() {
      return (
        ((this.window.outerHeight - this.window.innerHeight) /
          this.window.outerHeight) *
        100
      )
    },
    toolbarStyles() {
      return {
        height: `${this.toolbarHeight}%`
      }
    },
    systemToolbarHeight() {
      return (this.screen.availTop / this.screen.height) * 100
    },
    browswerStyles() {
      return {
        height: `${this.browserHeight}%`,
        width: `${this.browserWidth}%`,
        marginTop: `${this.systemToolbarHeight}%`
      }
    },
    browserInnerStyles() {
      return {
        height: `${this.browserInnerHeight}%`,
        width: `${this.browserInnerWidth}%`,
        top: `${this.toolbarHeight}%`
      }
    },
    screenStyles() {
      return {
        height: 0,
        paddingBottom: `${this.screenHeight}%`
      }
    }
  }
}
</script>
